import { getFontSize } from '../selectors/getFontSize';

export const setFontSizeOnDocument = (): void => {
    const fontSize = getFontSize();

    // Even if a browser doesn't support CSS variables, setting these values is benign
    const scale = getComputedStyle(document.body).getPropertyValue('--fontScale');
    if (scale) {
        document.body.style.setProperty('--fontScale', fontSize.toString());
    }
};
